module.exports = __webpack_public_path__ + "static/img/license_success.e4ca24d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workspace/license_success.png
// module id = ctr7
// module chunks = 1